<template>
  <v-card class="pa-4">
    <div class="d-flex justify-space-between align-center">
      <v-card-title class="display-1">{{ location.name }}</v-card-title>
      <v-icon
        large
        :color="order.hasBeenPaid ? 'primary' : null"
        @click.stop="maybeTogglePayment"
        class="mx-6"
      >
        {{ order.hasBeenPaid ? "mdi-cash" : "mdi-cash-remove" }}
      </v-icon>
    </div>
    <div v-for="(status, i) in ordersStatus" :key="i" class="ml-2">
      <div v-if="filterProducts(status).length > 0">
        <v-row class="mt-4 d-flex align-center">
          <v-col cols="1" @click="_ => clickStatus(status)">
            <v-checkbox
              :input-value="allSelected(status) ? true : undefined"
              :indeterminate="status === selectedStatus && !allSelected(status)"
              @click.prevent
            />
          </v-col>
          <v-col cols="8" @click="_ => clickStatus(status)">
            <v-card-title class="headline">{{ $t(status) }}</v-card-title>
          </v-col>
          <v-col cols="3">
            <v-row
              v-if="status === selectedStatus"
              class="d-flex justify-end mr-6"
            >
              <v-btn
                v-if="existsPrevious(status)"
                outlined
                small
                color="primary"
                icon
                @click="goTo(false)"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn
                v-if="existsNext(status)"
                outlined
                small
                color="primary"
                class="ml-12"
                icon
                @click="goTo(true)"
              >
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-divider />
        <OrderProductDetails
          v-for="(wrapper, i) in filterProducts(status)"
          :key="i"
          @clicked="() => onClick(wrapper)"
          :productWrapper="wrapper"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import { OrderProductStatus } from "@/model/order";
import OrderProductDetails from "./OrderProductDetails";

export default {
  props: ["order", "location"],
  data() {
    return {
      ordersStatus: Object.values(OrderProductStatus),
      productWrappers: [],
      selectedStatus: ""
    };
  },
  components: { OrderProductDetails },
  computed: {
    selectedWrappers() {
      return this.productWrappers.filter(wrapper => wrapper.selected);
    }
  },
  methods: {
    filterProducts(status) {
      return this.productWrappers.filter(
        wrapper => wrapper.product.status === status
      );
    },

    onClick(wrapper) {
      if (
        !this.selectedStatus ||
        this.selectedStatus === wrapper.product.status
      ) {
        wrapper.selected = !wrapper.selected;
      } else if (this.selectedStatus !== wrapper.product.status) {
        this.setSelectedAll(false, this.selectedStatus);
        wrapper.selected = !wrapper.selected;
        this.selectedStatus = "";
      }
      if (this.selectedStatus) {
        this.selectedStatus = this.anySelected(this.selectedStatus)
          ? this.selectedStatus
          : "";
      } else {
        this.selectedStatus = wrapper.product.status;
      }
    },

    noneSelected() {
      return !this.productWrappers.some(wrapper => wrapper.selected);
    },

    anySelected(status) {
      return this.productWrappers.some(wrapper =>
        status
          ? status === wrapper.product.status && wrapper.selected
          : wrapper.selected
      );
    },

    allSelected(status) {
      return this.productWrappers.every(wrapper =>
        status
          ? (status === wrapper.product.status && wrapper.selected) ||
            status !== wrapper.product.status
          : wrapper.selected
      );
    },

    clickStatus(status) {
      if (this.allSelected(status)) {
        this.setSelectedAll(false, status);
        this.selectedStatus = "";
      } else {
        if (this.selectedStatus && this.selectedStatus !== status) {
          this.setSelectedAll(false, this.selectedStatus);
        }
        this.setSelectedAll(true, status);
        this.selectedStatus = status;
      }
    },

    setSelectedAll(value, status) {
      this.productWrappers.forEach(wrapper => {
        if (wrapper.product.status === status) {
          wrapper.selected = value;
        }
      });
    },

    existsPrevious(status) {
      return OrderProductStatus.pending !== status;
    },

    existsNext(status) {
      return OrderProductStatus.delivered !== status;
    },

    goTo(isNext) {
      let to = OrderProductStatus[isNext ? "next" : "previous"](
        this.selectedStatus
      );
      if (to) {
        if (this.order.hasBeenPaid) {
          // TODO Cancel payment
        } else {
          this.order.updateProductsStatus(
            this.selectedStatus,
            to,
            this.productWrappers.filter(wrapper => wrapper.selected)
          );
          this.selectedStatus = "";
          this.productWrappers.forEach(wrapper => (wrapper.selected = false));
        }
      } else {
        if (!this.order.hasBeenPaid) {
          // TODO Make payment
        }
      }
    },

    maybeTogglePayment() {
      this.$emit(
        "openPaymentDialog",
        this.order.hasBeenPaid ? "cancelPayment" : "confirmPayment",
        this.order
      );
    }
  },

  created() {
    let i = 0;
    this.order.products.forEach(product =>
      this.productWrappers.push({
        product: product,
        selected: false,
        index: i++
      })
    );
  }
};
</script>

<style></style>
